import React, { useEffect, useState } from "react";
import CardContent from "@mui/material/CardContent";
import { Card, Modal } from "react-bootstrap";
import axios from "axios";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutFormStripe from "./CheckoutFormStripe";

function StripeModal(props) {
  const { amount, event_type, event_id, show, publicKey, clientSecret } = props;

  const [buffer, setBuffer] = useState(true);
  // useEffect(() => {
  //     makePayment()
  // }, [amount, show])

  const stripePromise = loadStripe(
    // publicKey
    "pk_live_51M7EDzIUEL35EfmyowFaTv6FVlbjTV5MzbbuQ6Aj6D0KkqEOBBLjrHeBGzWrrXpQzQWASy6rHJLZTrg86mnrG2zK00KzyyEnG4"
  );

  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <Card
          style={{ backgroundColor: "#3d3d3d", minHeight: 500 }}
          sx={{ minWidth: 275 }}
        >
          <div
            onClick={props?.onHide}
            className="d-flex justify-content-end p-2"
          >
            <div className="closeNotificationDrop text-center">X</div>
          </div>
          <CardContent>
            <center>
              {buffer ? (
                <Elements options={options} stripe={stripePromise}>
                  <CheckoutFormStripe
                    clientSecret={clientSecret}
                    amount={amount}
                    event_type={event_type}
                    event_id={event_id}
                    buffer={buffer}
                  />
                </Elements>
              ) : (
                <div class="spinner-border text-warning" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              )}
            </center>
          </CardContent>
        </Card>
      </Modal.Body>
    </Modal>
  );
}

export default StripeModal;
